import { flatten, pick } from "lodash";
import { makeAutoObservable, toJS } from "mobx";
import { getCurrentUserInfo, skipOnBoarding } from "../../apis/accountApi";
import { getListTagsApi } from "../../apis/campaignManagement";
import { getSetting } from "../../apis/settingApi";
import { ROUTE_PERMISSION } from "../../common/constants";

class DashboardStores {
  title = "";
  userFullName = "";
  titleButtons = [];
  filterBlocks = [];

  availableRoutes = [];

  userInfo = {};

  campaignTags = [];

  constructor() {
    makeAutoObservable(this);
  }

  isVP() {
    return toJS(this.userInfo)?.username?.toLowerCase()?.endsWith("@vpbank.com.vn");
  }

  async prepareRoute(routeStore, publicRouteStore) {
    const { data } = await getCurrentUserInfo();
    if (data?.id) {
      window.AirflexJS.setUserProperties({ user_id: data?.id, name: data?.fullname, email: data?.email });
    }
    this.userInfo = data;
    const permissions = data?.permissions?.map((p) => p.code) || [];
    const hasPerRoutes = flatten(Object.values(pick(ROUTE_PERMISSION, permissions)));
    this.availableRoutes = [...routeStore.filter((route) => hasPerRoutes.includes(route.path)), ...publicRouteStore];
  }

  hasAny(codes) {
    const permissions = this?.userInfo?.permissions?.map((p) => p.code) || [];
    return codes.some((code) => permissions.includes(code));
  }

  async getSetting(key, appId) {
    const res = await getSetting(key, appId);
    return res?.data?.value;
  }

  async getCampaignTags() {
    const { dataArray } = await getListTagsApi();
    this.campaignTags = dataArray;
  }

  skipOnBoarding() {
    skipOnBoarding();
    this.userInfo = { ...this.userInfo, is_new: false };
  }

  setTitle(title, subTitle) {
    document.title = typeof title === "string" ? title : subTitle;
    this.title = title;
  }

  setUserfullName(userFullName) {
    this.userFullName = userFullName;
  }

  setTitleButtons(data) {
    this.titleButtons = data;
  }

  setFilterBlocks(data) {
    this.filterBlocks = data;
  }
}
export const dashboardStores = new DashboardStores();
